/** ¿La ruta es un hub de reseñas? Oculta Header/Footer/Lía en rutas públicas y de operación. */
export function isReviewHubPath(pathname: string | null | undefined): boolean {
  return !!pathname && (
    /^\/tours\/[^/]+\/opina(?:-externa)?\/?$/.test(pathname) ||
    /^\/opina-[a-f0-9]{8}\/?$/.test(pathname)
  );
}
